<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#6783B2">
        <path
          d="M14.5 0c.245 0 .45.177.492.41L15 .5v5.022l-.004.038L15 5.5c0 .035-.004.07-.01.103l-.012.045-.014.039-.021.045-.016.029-.027.04-.027.032c-.008.01-.017.018-.026.027-.012.012-.024.022-.037.032l-.03.023-.044.026-.014.007-.02.01-.045.017.065-.027c-.037.018-.076.032-.115.04l-.017.004-.015.002c-.016.003-.032.005-.048.005L14.5 6h-5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L9.5 5h4.145c-1.19-1.87-3.06-3-5.145-3C4.91 2 2 4.91 2 8.5S4.91 15 8.5 15 15 12.09 15 8.5c0-.276.224-.5.5-.5s.5.224.5.5c0 4.142-3.358 7.5-7.5 7.5C4.358 16 1 12.642 1 8.5 1 4.358 4.358 1 8.5 1c2.171 0 4.132 1.04 5.5 2.776V.5c0-.245.177-.45.41-.492L14.5 0z"
          transform="translate(-1336 -620) translate(280 544) translate(0 56) translate(1048 12) translate(8 8)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'RetryIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
